import React from "react";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import API from "../../helpers/endpointservice";
import $ from "jquery";
import axios from "axios";
import Loader from "../../helpers/loader";
import CommonIcon from "../../helpers/icons";
import WarningComponent from "../../helpers/modal";
import Toaster from "../../helpers/toaster";
import PaginationComponent from "../../helpers/Pagination";
import { logoutFunction } from "../../custom/logoutFunction";
import swal from "sweetalert";
import moment from "moment";

class Vendors extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            order: "asc",
            sortBy: "vendorCode",
            currentUser: "",
            pageNewCount: false,
            isVendorLoader: false,
            height: window.innerHeight,
            isTab: false,
            isMobile: false,
            iswebMobile: false,
            isRadioMobile: false,
            isSmallMobile: false,
            vendorsList: [],
            currentPage: 1,
            perPage: 20,
            pageCount: 20,
            currentPage: 1,
            userId: 0,
            currentEdit: 0,
            emailError: false,
            mapping: false,
            newVendor: {
                id: 0,
                vendorCode: "",
                vendorName: "",
                email: "",
                address: "",
                contactNumber: "",
                contactPerson: "",
                comments: "",
                isActive: true,
                status: "Active"
            },
            vendorDetails: {
                id: 0,
                vendorCode: "",
                vendorName: "",
                email: "",
                address: " ",
                contactNumber: "",
                contactPerson: "",
                comments: "",
                isActive: true,
                status: ""
            },
            searchInputData: {
                vendorCode: "",
                vendorName: "",
                email: "",
                contactNumber: "",
                contactPerson: "",
                status: "",
            },
            validationMsg: false,
            isSearch: false,
            vendorCode: "",
            isToastError: false,
            isVendorCodeLimitExceed: false,
            limitError: {
                vendorCode: false,
                vendorName: false,
                email: false,
                contactNumber: false,
                contactPerson: false,
                address: false,
                comments: false
            }
        };
    }
    componentDidMount() {
        let user = localStorage.getItem("UserId");
        let currentuser = localStorage.getItem("Role")
        this.state.userId = user;
        this.state.currentUser = currentuser;
        this.setState({}, () => {
            this.GetVendorsList(this.state.currentPage, this.state.perPage)
        })
        $("body").removeClass("scrollhide");
        const intervals = setInterval(() => {
            this.resize();
        }, 10);

    }

    resize = () => {
        if (window.innerWidth < 1280) {
            this.state.isTab = true;
        }
        else {
            this.state.isTab = false;
        }
        if (window.innerWidth < 850) {
            this.state.isMobile = true;
        } else {
            this.state.isMobile = false;
        }
        if (window.innerWidth < 750) {
            this.state.isSmallMobile = true;
        } else {
            this.state.isSmallMobile = false;
        }
        if (window.innerWidth < 490) {
            this.state.isRadioMobile = true;
        } else {
            this.state.isRadioMobile = false;
        }
        if (window.innerWidth < 400) {
            this.state.iswebMobile = true;
        } else {
            this.state.iswebMobile = false;
        }

        this.state.height = window.innerHeight;
        this.setState({});
    };

    checkingMap = () => {
        let url = `${API.POST_VALIDATE_VENDOR}?id=${this.state.vendorDetails.id}`;
        this.setState({
            isVendorLoader: true
        })
        axios({
            method: "GET",
            url: url
        })
            .then((res) => {
                if (res.data === false) {
                    this.setState({
                        mapping: true,
                        isVendorLoader: false
                    })
                }
                else {
                    this.setState({
                        mapping: false,
                        isVendorLoader: false
                    })
                }
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
                console.log(error);
                this.setState({ isVendorLoader: false });
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    }

    GetVendorsList = (currentpage, perpage) => {
        const { isSearch, searchInputData } = this.state;
        this.setState({ isVendorLoader: true });
        let order = this.state.order === 'asc' ? true : false;
        let apiUrl = `${API.GET_VENDORS}?sortBy=${this.state.sortBy}&isSortAscending=${order}&pageNumber=${currentpage}&pageSize=${perpage}`;
        let searchValues = {
            vendorCode: searchInputData.vendorCode || null,
            vendorName: searchInputData.vendorName || null,
            status: searchInputData.status || null,
            email: searchInputData.email || null,
            contactNumber: searchInputData.contactNumber || null,
            contactPerson: searchInputData.contactPerson || null,
        }
        axios({
            method: "POST",
            url: apiUrl,
            // data: (isSearch === true) ? searchValues : {}
            data: searchValues
        })
            .then((res) => {
                if (res.status === 200) {
                    this.state.vendorsList = res.data.values;
                    this.state.pageCount = res.data.totalCount;
                    this.setState({ isVendorLoader: false }, () => { });
                }
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
                console.log(error);
                this.setState({ isVendorLoader: false, isSearch: false });
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });
    };

    fetchPaginationList = (currentPage, perPage) => {
        this.setState(
            {
                currentPage: currentPage,
                perPage: perPage,
            },
            () => {
                this.GetVendorsList(currentPage, perPage);
            }
        );
    };


    handleInputchange(e, field, type) {
        var pattern = /^[0-9]*[0-9]*$/;
        if (type === "Add") {
            if (field === "contactNumber") {
                if (pattern.test(e.target.value)) {
                    const phone = e.target.value;
                    this.state.newVendor[field] = phone;
                }
            }
            else if (field === "comments") {
                this.state.newVendor[field] = e.target.value;
            }
            else {
                if (e?.target?.value?.trim()?.length > 250) {
                    this.state.limitError[field] = true;
                } else if (e?.target?.value?.trim()?.length <= 250) {
                    this.state.newVendor[field] = e.target.value
                    this.state.limitError[field] = false;
                }
            }
            this.setState({});
        } else if (type === "Edit") {
            if (field === "contactNumber") {
                if (pattern.test(e.target.value)) {
                    const phone = e.target.value;
                    this.state.vendorDetails[field] = phone;
                }
            }
            // else if (field === "vendorCode") {
            //     if (e?.target?.value?.trim()?.length > 255 && this.state.isToastError == false) {
            //         this.setState({
            //             isToastError: true
            //         })
            //         setTimeout(() => {
            //             this.setState({
            //                 isToastError: false
            //             })
            //         }, 1000);
            //         toast.error(
            //             "You have reached your maximum limit of characters allowed.",
            //             {
            //                 position: toast.POSITION.TOP_RIGHT,
            //                 color: "#fff",
            //             }
            //         );
            //     } else if (e?.target?.value?.trim()?.length <= 255) {
            //         this.state.vendorDetails[field] = e.target.value;
            //     }
            // }
            else {
                if (e?.target?.value?.trim()?.length > 250) {
                    this.state.limitError[field] = true;
                } else if (e?.target?.value?.trim()?.length <= 250) {
                    this.state.vendorDetails[field] = e.target.value;
                    this.state.limitError[field] = false;
                }
                //this.state.vendorDetails[field] = e.target.value;
            }
            this.setState({});
        }
        else if (type === "Search") {
            if (field === "contactNumber") {
                if (pattern.test(e.target.value)) {
                    const phone = e.target.value;
                    this.state.searchInputData[field] = phone;
                }
            }
            else if (field === "requestedDate") {
                this.state.searchInputData[field] = e;
            } else {
                this.state.searchInputData[field] = e.target.value;
            }
            this.setState({});
        }
    }

    openSearch = () => {
        let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("searchScreen"));
        myOffcanvas.show();
        $("body").addClass("scrollhide");

        this.getEmployeeName();
    }

    getEmployeeName = () => {
        this.setState({ isVendorLoader: true });
        const { userId } = this.state
        let apiUrl = `${API.GET_EMPLOYEES}?userId=${userId}`;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((res) => {
                if (res.status === 200) {
                    this.state.employeeNameList = res?.data?.map((employee) => {
                        return {
                            value: employee.employeeName,
                            label: (
                                <>
                                    <span>{employee.employeeName}</span>
                                </>
                            ),
                        }
                    });
                    this.setState({
                        isVendorLoader: false
                    })
                }
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
                console.log(error);
                this.setState({ isVendorLoader: false });
                swal("Error!", "Something went wrong. Please try again.", "warning");
            })
    }

    clearSearchDetails = () => {
        this.clearSearchData();
        this.setState({}, () => this.GetVendorsList(this.state.currentPage, this.state.perPage));
        $("#searchScreen").removeClass("show");
        $("body").removeClass("scrollhide");
    }
    clearSearchData = () => {
        this.setState({
            searchInputData: {
                vendorCode: "",
                vendorName: "",
                email: "",
                contactNumber: "",
                contactPerson: "",
                status: ""
            },
            validationMsg: false,
            isSearch: false
        })
    }

    validateSearchRecords = () => {
        const inputs = document.querySelectorAll('.records-editinput-class[required]');
        const isValid = Array?.from(inputs)?.some(input => input.value !== '');
        if (isValid) {
            this.submitSearchDetails()
        } else {
            this.setState({
                validationMsg: true
            })
        }
    }

    submitSearchDetails = () => {
        this.state.isSearch = true;
        this.setState({}, () => this.GetVendorsList(this.state.currentPage, this.state.perPage));
        $("#searchScreen").removeClass("show");
        $("body").removeClass("scrollhide");
    }

    // End Search 

    vendorDetails = (Id) => {
        if (Id === 0) {
            this.setState({ currentEdit: 0 }, () => {
                this.clearAddVendor();
                let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("vendorpropertiesScreen"));
                myOffcanvas.show();
                $("body").addClass("scrollhide");
            });
        }
        else {
            this.setState({ currentEdit: Id }, () => {
                this.clearEditvendor()
                this.GetVendorDetails(Id)
            })
        }
    };

    GetVendorDetails = (Id) => {
        this.setState({ isVendorLoader: true });
        let apiUrl = `${API.Common_VENDOR}?id=${Id}`;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((res) => {
                if (res.status === 200) {
                    let historyLog = res.data.historyLog;
                    this.state.vendorDetails = { ...res.data, ...historyLog };
                    this.state.vendorCode = res.data.vendorCode;

                    this.setState({}, () => {
                        let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("vendorpropertiesScreen"));
                        myOffcanvas.show();
                        $("body").addClass("scrollhide");
                    });
                    this.state.isVendorLoader = false;
                    this.setState({})
                }
            }).catch((error) => {
                logoutFunction(error?.response?.status);
                console.log(error)
                this.setState({ isVendorLoader: false });
                swal("Error!", "Something went wrong. Please try again.", "warning");
            })
    }

    removeVendor = () => {
        let url = `${API.POST_VALIDATE_VENDOR}?id=${this.state.vendorDetails.id}`;
        this.setState({
            isVendorLoader: true
        })
        axios({
            method: "GET",
            url: url
        })
            .then((res) => {
                if (res.data === false) {
                    this.deleteVendor();
                }
                else {
                    this.setState({
                        isVendorLoader: false
                    })
                    toast.error("Not able to remove this vendor. This vendor is assigned to training.", {
                        position: toast.POSITION.TOP_RIGHT,
                        color: "#fff",
                    });
                }
            })
            .catch((error) => {
                logoutFunction(error?.response?.status);
                console.log(error);
                this.setState({ isVendorLoader: false });
                swal("Error!", "Something went wrong. Please try again.", "warning");
            });

    }

    deleteVendor = () => {
        this.setState({ isVendorLoader: true });
        let DeleteVendor = [
            this.state.vendorDetails.id
        ]
        let apiUrl = `${API.Common_VENDOR}?userId=${this.state.userId}`;
        axios({
            method: "DELETE",
            url: apiUrl,
            data: DeleteVendor,
        }).then((res) => {
            if (res.status === 200) {
                $("#vendorpropertiesScreen").removeClass("show");
                $("body").removeClass("scrollhide")
                toast.success("Vendor removed successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    color: "#fff",
                });
                this.GetVendorsList(this.state.currentPage, this.state.perPage)
                this.setState({})
            }
        }).catch((error) => {
            logoutFunction(error?.response?.status);
            console.log(error);
            this.setState({ isVendorLoader: false });
            swal("Error!", "Something went wrong. Please try again.", "warning");
            // toast.error("Failed to delete vendor",
            //     { position: toast.POSITION.TOP_RIGHT, color: "#fff", }
            // );
        })
    }


    sortTable = (name) => {
        let sortData = this.state.vendorsList;
        if (sortData.length !== 0) {
            if (this.state.sortBy === name) {
                this.state.sortBy = name;
                if (this.state.order === "asc") {
                    var ordernew = "desc"
                    this.state.order = ordernew;
                }
                else {
                    var ordernew = "asc"
                    this.state.order = ordernew;
                }
            }
            else {
                this.state.sortBy = name;
                this.state.order = 'asc'
            }
            this.state.currentPage = 1;
            this.state.pageNewCount = !this.state.pageNewCount;
            this.setState({}, () => {
                this.GetVendorsList(this.state.currentPage, this.state.perPage)
            })
        }
    };

    editVendor = () => {
        this.state.vendorDetails.status = (this.state.vendorDetails.isActive ? "Active" : "Inactive");
        const inputs = document.querySelectorAll('.vendor-editinput-class[required]');
        const isValid = Array.from(inputs).every(input => input.value !== '');
        const removeBorder = Array.from(inputs).filter(input => input.value != '');
        removeBorder?.forEach(input => {
            input.style.borderColor = '';
        });
        if (isValid) {
            var pattern =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!pattern.test(this.state.vendorDetails.email)) {
                $("#emailErrMsgEdit").text("Invalid Email");
                this.state.emailError = true;
                this.setState({})
                return;
            } else {
                if (this.state.vendorDetails.isActive === false) {
                    let url = `${API.POST_VALIDATE_VENDOR}?id=${this.state.vendorDetails.id}`;
                    this.setState({
                        isVendorLoader: true
                    })
                    axios({
                        method: "GET",
                        url: url
                    })
                        .then((res) => {
                            if (res.data === false) {
                                this.postVendorUpdate();
                            }
                            else {
                                this.setState({
                                    isVendorLoader: false
                                })
                                toast.error("Not able to Inactive this vendor. This vendor is assigned to training.", {
                                    position: toast.POSITION.TOP_RIGHT,
                                    color: "#fff",
                                });
                            }
                        })
                        .catch((error) => {
                            logoutFunction(error?.response?.status);
                            console.log(error);
                            this.setState({ isVendorLoader: false });
                            swal("Error!", "Something went wrong. Please try again.", "warning");
                        });

                } else {
                    this.postVendorUpdate();
                }

            }
        } else {
            const emptyInputs = Array.from(inputs).filter(input => input.value === '');
            if (emptyInputs?.length > 0) {
                emptyInputs.forEach(input => {
                    input.style.borderColor = 'red';
                    input.addEventListener('input', () => {
                        if (input.value !== '') {
                            input.style.borderColor = '';
                        }
                    });
                });
            }
        }
    };

    postVendorUpdate = () => {
        $("#emailErrMsgEdit").text("");
        this.state.emailError = false;
        this.setState({})
        let apiurl1 = `${API.VENDOR_EXISTS}?vendorCode=${this.state.vendorDetails.vendorCode}&id=${this.state.vendorDetails.id}`;
        this.setState({ isVendorLoader: true });
        axios({
            method: "GET",
            url: apiurl1,
        }).then((res) => {
            if (res.data === false) {
                let apiurl2 = `${API.VENDOR_EMAIL_VALIDATE}?email=${this.state.vendorDetails.email}&id=${this.state.vendorDetails.id}`;
                this.setState({ isVendorLoader: true });
                axios({
                    method: "GET",
                    url: apiurl2,
                }).then((response) => {
                    if (response.data === false) {
                        let apiUrl = `${API.Common_VENDOR}?userId=${this.state.userId}`;
                        axios({
                            method: "POST",
                            url: apiUrl,
                            data: this.state.vendorDetails,
                        }).then((res) => {
                            if (res.status === 200) {
                                $("#vendorpropertiesScreen").removeClass("show");
                                $("body").removeClass("scrollhide")
                                toast.success("Vendor edited successfully", {
                                    position: toast.POSITION.TOP_RIGHT,
                                    color: "#fff",
                                });
                                this.setState({ isVendorLoader: false }, () => {
                                    this.GetVendorsList(this.state.currentPage, this.state.perPage);
                                    this.clearEditvendor()
                                });
                            }
                        }).catch((error) => {
                            logoutFunction(error?.response?.status);
                            console.log(error);
                            // toast.error(
                            //     "Failed to edit vendor",
                            //     { position: toast.POSITION.TOP_RIGHT, color: "#fff", }
                            // );
                            swal("Error!", "Something went wrong. Please try again.", "warning");
                            this.setState({ isVendorLoader: false });
                        })
                    } else {
                        this.setState({ isVendorLoader: false })
                        toast.error(
                            "This email is already given. Please give another email.",
                            {
                                position: toast.POSITION.TOP_RIGHT,
                                color: "#fff",
                            }
                        );
                    }
                }
                );
            } else {
                this.setState({ isVendorLoader: false })
                toast.error(
                    "This vendor code is already given. Please give another code.",
                    {
                        position: toast.POSITION.TOP_RIGHT,
                        color: "#fff",
                    }
                );
            }

        }).catch((error) => {
            logoutFunction(error?.response?.status);
            console.log(error)
            this.setState({ isVendorLoader: false });
            swal("Error!", "Something went wrong. Please try again.", "warning");
        })
    }

    addVendor = () => {
        this.state.newVendor.status = (this.state.newVendor.isActive ? "Active" : "Inactive");
        const inputs = document.querySelectorAll('.vendor-input-class[required]');
        const isValid = Array.from(inputs).every(input => input.value !== '');
        const removeBorder = Array.from(inputs).filter(input => input.value != '');
        removeBorder?.forEach(input => {
            input.style.borderColor = '';
        });
        if (isValid) {
            var pattern =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!pattern.test(this.state.newVendor.email)) {
                $("#emailErrMsgAdd").text("Invalid Email");
                this.state.emailError = true;
                this.setState({})
                return;
            } else {
                $("#emailErrMsgAdd").text("");
                this.state.emailError = false;
                this.setState({})
                let apiurl1 = `${API.VENDOR_EXISTS}?vendorCode=${this.state.newVendor.vendorCode}&id=0`;
                this.setState({ isVendorLoader: true });
                axios({
                    method: "GET",
                    url: apiurl1,
                }).then((res) => {
                    if (res.data === false) {
                        let apiurl2 = `${API.VENDOR_EMAIL_VALIDATE}?email=${this.state.newVendor.email}&id=0`;
                        this.setState({ isVendorLoader: true });
                        axios({
                            method: "GET",
                            url: apiurl2,
                        }).then((response) => {
                            if (response.data === false) {
                                let apiUrl = `${API.Common_VENDOR}?userId=${this.state.userId}`;
                                axios({
                                    method: "POST",
                                    url: apiUrl,
                                    data: this.state.newVendor,
                                }).then((resp) => {
                                    if (resp.status === 200) {
                                        $("#vendorpropertiesScreen").removeClass("show");
                                        $("body").removeClass("scrollhide")

                                        toast.success("Vendor added successfully", {
                                            position: toast.POSITION.TOP_RIGHT,
                                            color: "#fff",
                                        });
                                        this.setState({ isVendorLoader: false }, () => {
                                            this.GetVendorsList(this.state.currentPage, this.state.perPage);
                                            this.clearAddVendor();
                                        });
                                    }
                                }).catch((error) => {
                                    logoutFunction(error?.response?.status);
                                    console.log(error)
                                    // toast.error(
                                    //     "Failed to add vendor",
                                    //     { position: toast.POSITION.TOP_RIGHT, color: "#fff", }
                                    // );
                                    this.setState({ isVendorLoader: false });
                                    swal("Error!", "Something went wrong. Please try again.", "warning");
                                })
                            } else {
                                this.setState({ isVendorLoader: false })
                                toast.error(
                                    "This email is already given. Please give another email.",
                                    {
                                        position: toast.POSITION.TOP_RIGHT,
                                        color: "#fff",
                                    }
                                );
                            }
                        }
                        );
                    } else {
                        this.setState({ isVendorLoader: false })
                        toast.error(
                            "This vendor code is already given. Please give another code.",
                            {
                                position: toast.POSITION.TOP_RIGHT,
                                color: "#fff",
                            }
                        );
                    }
                }).catch((error) => {
                    logoutFunction(error?.response?.status);
                    console.log(error);
                    this.setState({ isVendorLoader: false });
                    swal("Error!", "Something went wrong. Please try again.", "warning");
                })
            }

        } else {
            const emptyInputs = Array.from(inputs).filter(input => input.value === '');
            if (emptyInputs?.length > 0) {
                emptyInputs.forEach(input => {
                    input.style.borderColor = 'red';
                    input.addEventListener('input', () => {
                        if (input.value !== '') {
                            input.style.borderColor = '';
                        }
                    });
                });
            }

        }

    };

    clearAddVendor = () => {
        const inputs = document.querySelectorAll('.vendor-input-class[required]');
        const emptyInputs = Array.from(inputs).filter(input => input.value === '');
        if (emptyInputs?.length > 0) {
            emptyInputs.forEach(input => {
                input.style.borderColor = '';
            });
        }
        $("#emailErrMsgAdd").text("");
        this.state.emailError = false;
        this.state.newVendor = {
            id: 0,
            vendorCode: "",
            vendorName: "",
            email: "",
            address: "",
            contactNumber: "",
            contactPerson: "",
            comments: "",
            status: "Active",
            isActive: true

        }
        this.state.limitError = {
            vendorCode: false,
            vendorName: false,
            email: false,
            contactNumber: false,
            contactPerson: false,
            address: false,
            comments: false
        }
        this.setState({})
    }

    clearEditvendor = () => {
        const inputs = document.querySelectorAll('.vendor-search-class[required]');
        const emptyInputs = Array.from(inputs).filter(input => input.value === '');
        if (emptyInputs?.length > 0) {
            emptyInputs.forEach(input => {
                input.style.borderColor = '';
            });
        }
        $("#emailErrMsgEdit").text("");
        this.state.emailError = false;
        this.state.limitError = {
            vendorCode: false,
            vendorName: false,
            email: false,
            contactNumber: false,
            contactPerson: false,
            address: false,
            comments: false
        }
        this.setState({})
    }

    closeProperties = (type) => {
        $("#vendorpropertiesScreen").removeClass("show");
        $("body").removeClass("scrollhide")
        if (type === "Add") {
            this.clearAddVendor();
        } else {
            this.clearEditvendor()
        }

    }

    closeSearchScreen = () => {
        $("#searchScreen").removeClass("show");
        $("body").removeClass("scrollhide")
        // this.clearSearchDetails()

    }

    handleChangeToggle = (name) => {
        if (name === "Update") {
            this.state.vendorDetails.isActive = !this.state.vendorDetails.isActive
            this.setState({})
        } else if (name === "Add") {
            this.state.newVendor.isActive = !this.state.newVendor.isActive
            this.setState({})
        }
    }

    render() {
        const { isMobile, isTab, isVendorLoader, iswebMobile, sortBy, order, vendorsList, isRadioMobile, isSmallMobile, pageNewCount, isVendorCodeLimitExceed, limitError } = this.state;
        let { menuToggle } = this.props;
        return (
            <>
                <Toaster />
                {$("#vendorpropertiesScreen").hasClass("show") || $("#searchScreen").hasClass("show") ? <div className='viewbar-overlay'></div> : <></>}
                <div className={`${isMobile ? "main-body-mobile" : menuToggle ? "menu-main-body" : "main-body"} `}>
                    <Loader isLoader={isVendorLoader} />
                    <div className="head-fixed-company">
                        <>
                            {isMobile == true ? (
                                <div className="w-100 mobile-head border-bottom ">
                                    <div className="mobile-title">Vendors{" "}</div>
                                </div>
                            ) : (
                                <div className={` ${menuToggle ? "width-100" : "width-filter"} px-4 position-relative border-bottom row `}>
                                    <div className="col-6 border-none title">
                                        <CommonIcon fileName="Vendorslogo" /><span className="pl-10 head-span">Vendors{" "}</span></div>
                                </div>
                            )}
                        </>
                        <div className={`${isMobile ? "" : "pl-10"} border-bottom`}>
                            <div className={`col-12 d-flex justify-content-start  ${isMobile ? "pr-0 pl-17" : "pl-10 p-1"}`}>
                                <button className={`displaybutton ${isRadioMobile ? "pr-5" : ""} ${isSmallMobile ? "pl-5" : ""}`} onClick={() => this.vendorDetails(0)}>
                                    <CommonIcon fileName="addIcon" /><span className={`subhead-span p-2`}>Add</span>
                                </button>
                                <div
                                    className={`position-absolute  end-0 ${isMobile ? "" : menuToggle ? "ml-role-updated" : "ml-role"}`}>
                                    <button className="displaybutton" onClick={this.openSearch} >
                                        <span> <CommonIcon fileName="filterIcon" /></span>
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className={`${isMobile ? "favorite-mobile-table1" : "favorite-table1"} table-responsive w-100`}>
                        <div className={`table-fixed-header ${(isMobile ? "table-scroll-xy-mobile top-150px" : menuToggle ? "table-scroll-xy-menutoggle top-upcoming-training" : "table-scroll-xy top-upcoming-training")} table-list-view-bottom`} >
                            <table className={`table fileListTable2 table-borderless table-hover ${isMobile ? "" : ""}`}>
                                <thead>
                                    <tr>
                                        <td></td>
                                        <td className="cursor-pointer" onClick={() => this.sortTable("vendorCode")}>
                                            <span className="vendor-span">Vendor code</span> {sortBy === "vendorCode" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />}
                                        </td>
                                        <td className="cursor-pointer" onClick={() => this.sortTable("vendorName")}>
                                            <span className="vendor-span">Vendor name</span> {sortBy === "vendorName" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />}
                                        </td>
                                        <td className="cursor-pointer" onClick={() => this.sortTable("address")}>
                                            <span className="vendor-span">Address</span> {sortBy === "address" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />}
                                        </td>

                                        <td className="cursor-pointer" onClick={() => this.sortTable("contactPerson")}>
                                            <span className="vendor-span">Contact person</span>  {sortBy === "contactPerson" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />}
                                        </td>
                                        <td className="cursor-pointer" onClick={() => this.sortTable("contactNumber")}>
                                            <span className="vendor-span">Contact number</span> {sortBy === "contactNumber" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />}
                                        </td>
                                        <td className="cursor-pointer" onClick={() => this.sortTable("email")}>
                                            <span className="vendor-span">Email</span> {sortBy === "email" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />}
                                        </td>
                                        <td className="cursor-pointer" onClick={() => this.sortTable("status")}>
                                            <span className="vendor-span">Status</span> {sortBy === "status" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />}
                                        </td>
                                        <td className="cursor-pointer" onClick={() => this.sortTable("comments")}>
                                            <span className="vendor-span">Comments</span> {sortBy === "comments" && <CommonIcon fileName={order === "asc" ? "upArrow" : "downArrow"} />}
                                        </td>

                                    </tr>
                                </thead>
                                <tbody>
                                    {vendorsList.length !== 0 ?
                                        vendorsList.map((item, index) => (
                                            <tr key={index} >
                                                <td></td>
                                                <td className="width-150px"><span><a className="link cursor-pointer" onClick={() => this.vendorDetails(item.id)}>{item.vendorCode}</a></span></td>
                                                <td className="width-150px"><span>{item.vendorName}</span></td>
                                                <td className="width-vendor-address"><span className="text-wrap">{item.address}</span></td>
                                                <td className="width-150px"><span>{item.contactPerson}</span></td>
                                                <td className="width-150px"><span>{item.contactNumber}</span></td>
                                                <td className="width-150px"><span>{item.email}</span></td>
                                                <td className="width-150px"><span>{item.status}</span></td>
                                                <td><span className="text-wrap tableAddress">{item.comments}</span></td>
                                                {/* <td></td> */}
                                            </tr>
                                        )) :
                                        <tr> <td colSpan={8} className="table-nodata">{vendorsList && "No record found"}</td> </tr>}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className={`${isMobile ? "common-mobilesubmenu mobile-pagination" : menuToggle ? "common-submenu sidemenu-pagination" : "common-submenu web-pagination"} pb-2 pt-2`}> </div>
                </div>

                <div className={`offcanvas offcanvas-end offcanvasStyle ${this.state.vendorDetails?.historyLog?.length > 0 ? "audit-offcanvas" : ''}`} tabIndex={-1} data-bs-scroll="false" data-bs-backdrop="false" id="vendorpropertiesScreen" aria-labelledby="offcanvasScrollingLabel">
                    {
                        this.state.currentEdit !== 0 ?
                            <>
                                <div className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3 mt-10"}`}>
                                    <h6 id="offcanvasRightLabel" className="modal-title pr-10 text-break head-span fw-600">
                                        {this.state.vendorCode}
                                    </h6>
                                    <button className={`text-reset offcavasclose cross-icon-fixed  buttonstyle background-white ${isMobile ? "pr-0" : ""}`} onClick={() => this.closeProperties("Edit")}>
                                        <CommonIcon fileName="CrossIcon" />
                                    </button>
                                </div>

                                <div className="offcanvas-body px-4 pt-0">
                                    <div className="row">
                                        <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                            <div className="form-group">
                                                <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                                    <CommonIcon fileName="VendorCodeIcon" /><span className="pl-5 properties-span-2">Vendor code</span><span className="MuiFormHelperText-contained">*</span>
                                                </label>
                                                <input type="text" autocomplete="off" className={`form-control form-text-box vendor-editinput-class ${limitError.vendorCode === true ? "Error-border" : ""}`} id="vendorCode" value={this.state.vendorDetails.vendorCode} onChange={(e) => this.handleInputchange(e, "vendorCode", "Edit")} required />
                                            </div>
                                            {limitError.vendorCode ? <span className="spanErrMsg">Value must be less than 250 characters</span> : <></>}
                                        </div>
                                        <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                            <div className="form-group">
                                                <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                                    <CommonIcon fileName="VendorNameIcon" /><span className="pl-5 properties-span-2 ">Vendor name</span><span className="MuiFormHelperText-contained">*</span>
                                                </label>
                                                <input type="text" autocomplete="off" className={`form-control form-text-box vendor-editinput-class ${limitError.vendorName === true ? "Error-border" : ""}`} id="vendorName" value={this.state.vendorDetails.vendorName} onChange={(e) => this.handleInputchange(e, "vendorName", "Edit")} required />
                                            </div>
                                            {limitError.vendorName ? <span className="spanErrMsg">Value must be less than 250 characters</span> : <></>}
                                        </div>

                                        <div className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                            <div className="form-group">
                                                <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                                    <CommonIcon fileName="ContactPersonIcon" /><span className="pl-7 properties-span-2">Contact person</span><span className="MuiFormHelperText-contained">*</span>
                                                </label>
                                                <input type="text" autocomplete="off" className={`form-control form-text-box vendor-editinput-class ${limitError.contactPerson === true ? "Error-border" : ""}`} id="contactPerson" value={this.state.vendorDetails.contactPerson} onChange={(e) => this.handleInputchange(e, "contactPerson", "Edit")} required />
                                            </div>
                                            {limitError.contactPerson ? <span className="spanErrMsg">Value must be less than 250 characters</span> : <></>}
                                        </div>
                                        <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                            <div className="form-group">
                                                <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                                    <CommonIcon fileName="ContactNumberIcon" /><span className="pl-5 properties-span-2">Contact number</span><span className="MuiFormHelperText-contained">*</span>
                                                </label>
                                                <input type="text" autocomplete="off" className={`form-control form-text-box vendor-editinput-class`} pattern="[0-9]*" id="contactNumber" value={this.state.vendorDetails.contactNumber} onChange={(e) => this.handleInputchange(e, "contactNumber", "Edit")} required />
                                            </div>
                                        </div>
                                        <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                            <div className="form-group">
                                                <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                                    <CommonIcon fileName="VendorEmail" /><span className="pl-5 properties-span-2">Email</span><span className="MuiFormHelperText-contained">*</span>
                                                </label>
                                                <input type="text" autocomplete="off" className={`form-control form-text-box vendor-editinput-class ${this.state.emailError === true || limitError.email === true ? "Error-border" : ""}`} id="email" value={this.state.vendorDetails.email} onChange={(e) => this.handleInputchange(e, "email", "Edit")} required />
                                                <span id="emailErrMsgEdit" className="spanErrMsg"></span>
                                            </div>
                                            {limitError.email ? <span className="spanErrMsg">Value must be less than 250 characters</span> : <></>}
                                        </div>
                                        <div className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                            <div className="form-group">
                                                <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                                    <CommonIcon fileName="AddressIcon" /><span className="pl-5 properties-span-2">Address</span><span className="MuiFormHelperText-contained">*</span>
                                                </label>
                                                <textarea class={`form-control form-text-box-textarea vendor-editinput-class text-wrap resize-none ${limitError.address === true ? "Error-border" : ""}`} id="address" value={this.state.vendorDetails.address} onChange={(e) => this.handleInputchange(e, "address", "Edit")} required></textarea>
                                            </div>
                                            {limitError.address ? <span className="spanErrMsg">Value must be less than 250 characters</span> : <></>}
                                        </div>

                                        <div className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                            <div className="form-group">
                                                <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                                    <CommonIcon fileName="CommentIcon" /><span className="pl-5 properties-span-2">Comments</span>
                                                </label>
                                                <textarea class="form-control form-text-box-textarea mt-1 text-wrap resize-none" id="comments" value={this.state.vendorDetails.comments} onChange={(e) => this.handleInputchange(e, "comments", "Edit")}></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={isMobile ? "col-12" : "col-12"}>

                                        <label
                                            className={
                                                isMobile
                                                    ? "d-flex pt-2 m-0"
                                                    : "d-flex m-0 text-left float-start"
                                            }
                                        >
                                            <CommonIcon
                                                className="properties-img-2"
                                                fileName="MyselfIcon"
                                            />
                                            <span className="pl-5 properties-span-2">
                                                Status&nbsp;
                                            </span>
                                            &nbsp;
                                        </label>
                                    </div>

                                    <div
                                        className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 d-flex`}
                                    >
                                        <div class={` ${"form-check form-switch"}`}>
                                            <input class={`${"form-check-input toggle-button"}`} type="checkbox" role="switch" id="flexSwitchCheckChecked" onChange={() => this.handleChangeToggle("Update")} checked={this.state.vendorDetails.isActive} />
                                        </div>
                                        <label class={`mt-1 pl-10 view-text`}
                                        // for={this.state.allowDisable == false ? "" : "flexSwitchCheckChecked"}
                                        >
                                            {this.state.vendorDetails.isActive == true ? "Active" : "Inactive"}</label>
                                    </div>
                                    <div className="d-flex mt-3">
                                        <button className={`btn rejectbutton`} data-bs-toggle="modal" data-bs-target="#CancelCourseScreen" data-bs-dismiss="offcanvas">
                                            <CommonIcon fileName="ButtonRejectApprovalIcon" /><span className="pl-vendor3" onClick={this.checkingMap}>Remove</span></button>
                                        <button className={`btn approvebutton ml-10`} onClick={() => this.editVendor()} >
                                            <CommonIcon fileName="VendorSubmit" /><span className="model-label pl-vendor3">Update</span></button>
                                    </div>
                                    {
                                        this.state.vendorDetails?.historyLog?.length > 0 && <div>
                                            <div className="pt-3">
                                                <h6 className="modal-title">Audit log</h6>
                                            </div>
                                            <div className="audit-table-wrapper audit-scroll-css">
                                                <table className="px-3 audit-table w-100">
                                                    <thead>
                                                        <tr className="border-bottom">
                                                            <th className="p-rem">
                                                                Action
                                                            </th>
                                                            <th className="p-rem">
                                                                Action By
                                                            </th>
                                                            <th className="p-rem wid-45">
                                                                Description
                                                            </th>
                                                            <th className="p-rem">
                                                                Date
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.vendorDetails?.historyLog.map(x => (
                                                                <tr className="border-bottom">
                                                                    <td className="p-rem">{x.action ? x.action : "-"}</td>
                                                                    <td className="p-rem">{x.actionBy ? x.actionBy : "-"}</td>
                                                                    <td className="p-rem">
                                                                        {x.description ? x.description : "-"}
                                                                    </td>
                                                                    <td className="p-rem">
                                                                        {x.createdTime ? moment.utc(x.createdTime).local().format("DD-MMM-YYYY, hh:mm A") : "-"}
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </>
                            :
                            <>
                                {/* Heading */}
                                <div className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3 mt-10"}`}>
                                    <h6 id="offcanvasRightLabel" className="modal-title head-span fw-600">Add vendor</h6>
                                    <button className={`text-reset offcavasclose buttonstyle ${isMobile ? "pr-0" : ""}`} onClick={() => this.closeProperties("Add")}>
                                        <CommonIcon fileName="CrossIcon" /></button>
                                </div>
                                <div className="offcanvas-body px-4 pt-0">
                                    <div className="row">
                                        <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "pr-0" : "pb-3"}`}>
                                            <div className="form-group">
                                                <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                                    <CommonIcon fileName="VendorCodeIcon" /><span className="pl-5 properties-span-2">Vendor code</span><span className="MuiFormHelperText-contained">*</span>
                                                </label>
                                                <input type="text" autocomplete="off" className={`form-control form-text-box vendor-input-class ${limitError.vendorCode === true ? "Error-border" : ""}`} id="vendorCode1" value={this.state.newVendor.vendorCode} onChange={(e) => this.handleInputchange(e, "vendorCode", "Add")} required />
                                            </div>
                                            {limitError.vendorCode ? <span className="spanErrMsg">Value must be less than 250 characters</span> : <></>}
                                        </div>
                                        <div
                                            className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                            <div className="form-group">
                                                <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                                    <CommonIcon fileName="VendorNameIcon" /><span className="pl-5 properties-span-2 ">Vendor name</span><span className="MuiFormHelperText-contained">*</span>
                                                </label>
                                                <input type="text" autocomplete="off" className={`form-control form-text-box vendor-input-class ${limitError.vendorName === true ? "Error-border" : ""}`} id="vendorName1" value={this.state.newVendor.vendorName} onChange={(e) => this.handleInputchange(e, "vendorName", "Add")} required />
                                            </div>
                                            {limitError.vendorName ? <span className="spanErrMsg">Value must be less than 250 characters</span> : <></>}
                                        </div>
                                        <div
                                            className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                            <div className="form-group">
                                                <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                                    <CommonIcon fileName="ContactPersonIcon" /><span className="pl-7 properties-span-2">Contact person</span><span className="MuiFormHelperText-contained">*</span>
                                                </label>
                                                <input type="text" autocomplete="off" className={`form-control form-text-box vendor-input-class ${limitError.contactPerson === true ? "Error-border" : ""}`} id="contactPerson1" value={this.state.newVendor.contactPerson} onChange={(e) => this.handleInputchange(e, "contactPerson", "Add")} required />
                                            </div>
                                            {limitError.contactPerson ? <span className="spanErrMsg">Value must be less than 250 characters</span> : <></>}
                                        </div>
                                        <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                            <div className="form-group">
                                                <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                                    <CommonIcon fileName="ContactNumberIcon" /><span className="pl-5 properties-span-2">Contact number</span><span className="MuiFormHelperText-contained">*</span>
                                                </label>
                                                <input type="text" autocomplete="off" className={`form-control form-text-box vendor-input-class`} id="contactNumber1" pattern="[0-9]*" value={this.state.newVendor.contactNumber} onChange={(e) => this.handleInputchange(e, "contactNumber", "Add")} required />
                                            </div>
                                        </div>
                                        <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                            <div className="form-group">
                                                <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                                    <CommonIcon fileName="VendorEmail" />{" "}<span className="pl-5 properties-span-2">Email</span>&nbsp;<span className="MuiFormHelperText-contained">*</span>
                                                </label>
                                                <input type="text" autocomplete="off" className={`form-control form-text-box vendor-input-class  ${this.state.emailError === true || limitError.email === true ? "Error-border" : ""}`} id="email1" value={this.state.newVendor.email} onChange={(e) => this.handleInputchange(e, "email", "Add")} required />
                                                <span id="emailErrMsgAdd" className="spanErrMsg"></span>
                                            </div>
                                            {limitError.email ? <span className="spanErrMsg">Value must be less than 250 characters</span> : <></>}
                                        </div>
                                        <div className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                            <div className="form-group">
                                                <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                                    <CommonIcon fileName="AddressIcon" />{" "} <span className="pl-5 properties-span-2">Address</span><span className="MuiFormHelperText-contained">*</span>
                                                </label>
                                                <textarea class={`form-control form-text-box-textarea text-wrap resize-none vendor-input-class ${limitError.address === true ? "Error-border" : ""}`} id="address1" value={this.state.newVendor.address} onChange={(e) => this.handleInputchange(e, "address", "Add")} required></textarea>
                                            </div>
                                            {limitError.address ? <span className="spanErrMsg">Value must be less than 250 characters</span> : <></>}
                                        </div>
                                        <div className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                            <div className="form-group">
                                                <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                                    <CommonIcon fileName="CommentIcon" />{" "}<span className="pl-5 properties-span-2">Comments</span>
                                                </label>
                                                <textarea class="form-control form-text-box-textarea text-wrap resize-none mt-1" id="comments1" value={this.state.newVendor.comments} onChange={(e) => this.handleInputchange(e, "comments", "Add")}></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={isMobile ? "col-12" : "col-12"}>

                                        <label
                                            className={
                                                isMobile
                                                    ? "d-flex pt-2 m-0"
                                                    : "d-flex m-0 text-left float-start"
                                            }
                                        >
                                            <CommonIcon
                                                className="properties-img-2"
                                                fileName="MyselfIcon"
                                            />
                                            <span className="pl-5 properties-span-2">
                                                Status&nbsp;
                                            </span>
                                            &nbsp;
                                        </label>
                                    </div>

                                    <div
                                        className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 d-flex`}
                                    >
                                        <div class={` ${"form-check form-switch"}`}>
                                            <input class={`${"form-check-input toggle-button"}`} type="checkbox" role="switch" id="flexSwitchCheckChecked" onChange={() => this.handleChangeToggle("Add")} checked={this.state.newVendor.isActive} />
                                        </div>
                                        <label class={`mt-1 pl-10 view-text`}
                                        // for={this.state.allowDisable == false ? "" : "flexSwitchCheckChecked"}
                                        >
                                            {this.state.newVendor.isActive == true ? "Active" : "Inactive"}</label>
                                    </div>
                                    <div className="row mt-1">
                                        {/* Submit Button */}
                                        <div className="row mt-1">
                                            <div className={`${iswebMobile ? "col-12" : "col-6 pl-0"} col-sm-7 col-md-7 col-lg-7 col-xl-7 mb-3 ${iswebMobile ? "mt-2" : isMobile ? "mt-4 ml-8" : "mt-2 ml-8"} `}>
                                                <button className={`btn btn-light input-group offcavasclose filter-nextbtn p-2`} onClick={() => this.addVendor()}>
                                                    <CommonIcon fileName="vendoraddIcon" /><span className="model-label pl-5">Add</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                    }

                </div >

                {/* <div className={` viewbar-search viewbarOpen visible-hide`} id="searchScreen"> */}
                <div className="offcanvas offcanvas-end offcanvasStyle" tabIndex={-1} data-bs-scroll="false" data-bs-backdrop="false" id="searchScreen" aria-labelledby="offcanvasScrollingLabel">

                    {/* <div className="viewMain">
                        <div className="viewTitle mb-2 px-4 pt-4">
                            <h6 id="offcanvasRightLabel" className="modal-title head-span">Search</h6>
                            <button className={`text-reset offcavasclose buttonstyle ${isMobile ? "pr-0" : ""}`} onClick={() => this.closeProperties()}>
                                <CommonIcon fileName="CrossIcon" />
                            </button>{" "}
                        </div> */}
                    <div className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}>

                        <h6 id="offcanvasRightLabel" className="modal-title head-span fw-600">Search</h6>

                        <button
                            className={`text-reset offcavasclose buttonstyle ${isMobile ? "pr-0" : "pr-0"}`} onClick={this.closeSearchScreen}>
                            <CommonIcon fileName="CrossIcon" className="cursor-pointer app-image-hover" />
                        </button>{" "}
                    </div>

                    <div className="offcanvas-body px-4 pt-0">
                        <div className="row">
                            <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                <div className="form-group">
                                    <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                        <CommonIcon fileName="VendorCodeIcon" />{" "}<span className="pl-5 properties-span-2">Vendor code</span>
                                    </label>
                                    <input type="text" autocomplete="off" className="form-control form-text-box vendor-search-class records-editinput-class" id="vendorCode1" value={this.state.searchInputData.vendorCode} onChange={(e) => this.handleInputchange(e, "vendorCode", "Search")} required />
                                </div>
                            </div>
                            <div
                                className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                <div className="form-group">
                                    <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                        <CommonIcon fileName="VendorNameIcon" />{" "}<span className="pl-5 properties-span-2 ">Vendor name</span>
                                    </label>
                                    <input type="text" autocomplete="off" className="form-control form-text-box vendor-search-class records-editinput-class" id="vendorName1" value={this.state.searchInputData.vendorName} onChange={(e) => this.handleInputchange(e, "vendorName", "Search")} required />
                                </div>
                            </div>
                            <div
                                className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                <div className="form-group">
                                    <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                        <CommonIcon fileName="ContactPersonIcon" /><span className="pl-7 properties-span-2">Contact person</span>
                                    </label>
                                    <input type="text" autocomplete="off" className="form-control form-text-box vendor-search-class records-editinput-class" id="contactPerson1" value={this.state.searchInputData.contactPerson} onChange={(e) => this.handleInputchange(e, "contactPerson", "Search")} required />
                                </div>
                            </div>
                            <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                <div className="form-group">
                                    <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                        <CommonIcon fileName="ContactNumberIcon" /><span className="pl-5 properties-span-2">Contact number</span>
                                    </label>
                                    <input type="text" autocomplete="off" className="form-control form-text-box vendor-search-class records-editinput-class" id="contactNumber1" pattern="[0-9]*" value={this.state.searchInputData.contactNumber} onChange={(e) => this.handleInputchange(e, "contactNumber", "Search")} required />
                                </div>
                            </div>
                            <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                <div className="form-group">
                                    <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                        <CommonIcon fileName="VendorEmail" /><span className="pl-5 properties-span-2">Email</span>
                                    </label>
                                    <input type="text" autocomplete="off" className={`form-control form-text-box vendor-search-class records-editinput-class `} id="email1" value={this.state.searchInputData.email} onChange={(e) => this.handleInputchange(e, "email", "Search")} required />
                                    <span id="emailErrMsgAdd" className="spanErrMsg"></span>
                                </div>
                            </div>
                            <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                <div className="form-group">
                                    <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                        <CommonIcon fileName="MyselfIcon" />{" "}<span className="pl-5 properties-span-2">Status</span>
                                    </label>
                                    <input type="text" autocomplete="off" className="form-control form-text-box vendor-search-class records-editinput-class" value={this.state.searchInputData.status} onChange={(e) => this.handleInputchange(e, "status", "Search")} required />
                                </div>
                            </div>
                            {/* <div className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                    <div className="form-group">
                                        <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                            <CommonIcon fileName="CommentIcon" />{" "}<span className="pl-5 properties-span-2">Comments</span>
                                        </label>
                                        <textarea class="form-control form-text-box-textarea text-wrap resize-none mt-1" id="comments1" value={this.state.searchInputData.} onChange={(e) => this.handleInputchange(e, "comments", "Search")}></textarea>
                                    </div>
                                </div> */}
                        </div>

                        {this.state.validationMsg ? <span className="properties-span-2 text-danger">Atleast one field is mandatory</span> : ""}

                        <div className="d-flex mt-20">
                            <button className={`btn rejectbutton d-flex gap-1`} onClick={() => this.clearSearchDetails()}>
                                <span className="mt-0"><CommonIcon fileName="clearIcon1" />
                                </span><span className="pl-vendor3 pl-2">Clear</span>
                            </button>
                            <button className={`btn approvebutton ml-10 d-flex gap-1`} onClick={() => this.validateSearchRecords()}>
                                <span className=""><CommonIcon fileName="searchableIcon" /></span>
                                <span className="model-label pl-vendor3 pl-2">Search</span></button>
                        </div>
                    </div>

                    {/* </div> */}
                </div>


                {/* Modal - Warning */}
                <WarningComponent
                    message={`${this.state.mapping ? "This Vendor is tagged to courses.  " : ""} Are you sure you want to remove this Vendor?`}

                    isMobile={this.state.isMobile}
                    onYesClick={() => this.removeVendor()} />

                {/* Pagination */}
                {vendorsList?.length !== 0 ?
                    <PaginationComponent fetchPagination={this.fetchPaginationList} pageCount={this.state.pageCount} reset={pageNewCount} /> : null}
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return { dispatch };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(Vendors)
);
